import React, {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useState
} from "react";

import {
  fetchEducationDirections
} from "../api/educationDirectionsApi";


export const EducationDirectionsContext =
  createContext(null);


export const EducationDirectionsProvider = ({
  children
}) => {
  const [
    educationDirections,
    setEducationDirections
  ] = useState({});

  const [
    isLoading,
    setIsLoading
  ] = useState(true);

  const [
    error,
    setError
  ] = useState(null);

  const loadEducationDirections =
    useCallback(async (signal) => {
      setIsLoading(true);
      setError(null);

      try {
        const directions =
          await fetchEducationDirections({
            signal
          });

        setEducationDirections(directions);
      } catch (requestError) {
        if (
          requestError.name === "AbortError"
        ) {
          return;
        }

        setEducationDirections({});
        setError(requestError);
      } finally {
        if (!signal?.aborted) {
          setIsLoading(false);
        }
      }
    }, []);

  useEffect(() => {
    const controller =
      new AbortController();

    loadEducationDirections(
      controller.signal
    );

    return () => {
      controller.abort();
    };
  }, [
    loadEducationDirections
  ]);

  const getDirection = useCallback(
    (branchSymbol) => {
      if (!branchSymbol) {
        return null;
      }

      return educationDirections[
        branchSymbol.trim().toLowerCase()
      ] ?? null;
    },
    [
      educationDirections
    ]
  );

  const value = useMemo(() => ({
    educationDirections,
    getDirection,
    isLoading,
    error,
    reload: () =>
      loadEducationDirections()
  }), [
    educationDirections,
    getDirection,
    isLoading,
    error,
    loadEducationDirections
  ]);

  return (
    <EducationDirectionsContext.Provider
      value={value}
    >
      {children}
    </EducationDirectionsContext.Provider>
  );
};